<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9" @submit.prevent="validar()">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-9">
                        <h2 class="mb-0" v-if="modo == 'Creando'">Nuevo Cliente</h2>
                        <h2 class="mb-0" v-else >Modificando Cliente</h2>

                        <div class="text-end">
                            <router-link to="/clientes" class="btn btn-outline-primary text-nowrap">Regresar</router-link>
                        </div>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-3">
                    <div class="d-flex">
                        <button type="submit" class="btn btn-primary  w-100 text-nowrap">Publicar empresa</button>
                    </div>
                    </div>
                 
                </div>
                <div class="row g-5">
                    <div class="col-xl-8">
                        <div class="row gx-3 gy-4">
                            <div class="col-sm-6 col-md-12">
                                <div class="form-floating">
                                    <input class="form-control" v-model="empresa.nombre" type="text" placeholder="nombre del empresa" />
                                    <label for="floatingEventInput">Nombre</label>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input class="form-control" v-model="empresa.rfc" type="text"  />
                                    <label for="floatingEventInput">RFC</label>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <div class="mb-6">
                                    <div class="form-floating">
                                        <select  class="form-control" v-model="empresa.activado">
                                            <option value="1">Activo</option>
                                            <option value="0">Inactivo</option>
                                        </select>
                                        <label for="floatingEventInput">Estatus</label>
                                   </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <div class="mb-6">
                                    <div class="form-floating">
                                        <select  class="form-control" v-model="empresa.bloqueado">
                                            <option value="1">Bloqueado</option>
                                            <option value="0">Desbloqueado</option>
                                        </select>
                                        <label for="floatingEventInput">Actividad</label>
                                   </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xl-4">
                        <div class="row">
                            <div class="col-8"><h4>Sistemas</h4></div>
                            <div class="form-check" v-for="(sistema, key) in sistemas" :key="'indice-'+key">
                                <input class="form-check-input sistema" v-model="sistemasSelected" :id="'sistema-'+key" :value="sistema.id" type="checkbox"  />
                                <label class="form-check-label" :for="'sistema-'+key">{{ sistema.nombre }}</label>
                            </div>
                        </div>
                      
                    </div>
                </div>
            </form>
        </div>
    </section>
  </template>
  
  <script>
  // @ is an alias to /src
  import SideBar from '@/components/SideBarNav.vue'
  import TopBar from '@/components/TopBarNav.vue'
  import axios from 'axios'
  
  export default {
    name: 'CrearEmpresaView',
    components:{SideBar,TopBar},
    data(){
        return{
            empresa:{},
            sistemas:{},
            sistemasSelected:[],
            modo: (this.$route.params.id > 0 ? 'Modificando' : 'Creando'),
        }
    },
    created(){
        this.getSistemas()
        if(this.modo == 'Modificando') this.getData()
    },
    methods:{
        validar(){
            if(!this.empresa.nombre){
                this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: 'Debe agregar un nombre a la empresa',
                        type: 'error'
                    });
            }else{
                this.setEmpresa()
            }
        },
        setEmpresa(){
            let data = {
                empresa: this.empresa,
                sistemas: this.sistemasSelected
            }
            axios.post(this.$url+(this.modo == 'Creando' ? '/empresa' : '/empresa/'+this.$route.params.id),data,{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                if(res.data.message){
                    this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: res.data.message,
                        type: 'error'
                    });
                }else{
                    this.$router.push({name: 'clientes'})
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: err.response.data.message,
                    type: 'error'
                });
            })
        },
        getSistemas(){
            axios.get(this.$url+'/sistemas',{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                if(res.data.message){
                    this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: res.data.message,
                        type: 'error'
                    });
                }else{
                    this.sistemas = res.data
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                    group: 'iasc',
                    title: 'Error',
                    text: err.response.data.message,
                    type: 'error'
                });
            })
        },
        getData(){
            axios.get(this.$url+'/empresa/'+this.$route.params.id,{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                if(res.data.message){
                    this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: res.data.message,
                        type: 'error'
                    });
                }else{
                    this.empresa = res.data.empresa
                    this.sistemasSelected = res.data.sistemas.map(s=>s.sistema_id)
                }
            }).catch((err)=>{
                if(err.response) {
                    if(err.response.status == 500) this.logout()
                }
                this.$notify({
                        group: 'iasc',
                        title: 'Error',
                        text: err.response.data.message,
                        type: 'error'
                    });
            })
        }
    }
  }
  </script>
  